module.exports = __webpack_public_path__ + "static/media/entre_amigos2022-removebg.a02ff3b1.png";